/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Apply the preferences state object
 *
 * @param  {Object} state
 * @param  {Object} preferences
 * @return {Void}
 */
const SET_PREFERENCES = (state, preferences) => {
    state.data = preferences
}

/**
 * Update the state's selected prefernces
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const UPDATE_LOCAL_PREFERENCE = (state, payload) => {
    let target = state.data[payload.parent].data.find(item => item.key === payload.key)

    if (target) {
        target.selected = payload.selected
    }
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Update the unit/decimal state objects
 *
 * @param  {Object} state
 * @return {Void}
 */
const UPDATE_CURRENCY_PREFERENCE = (state, payload) => {
    state[payload.type] = payload.value

    if (payload.type === 'selectedUnitPreference' && payload.value !== 'dollars') {
        state['selectedDecimalPreference'] = 2
    }
}

export default {
    RESET_STATE,
    SET_PREFERENCES,
    UPDATE_LOCAL_PREFERENCE,
    UPDATE_CURRENCY_PREFERENCE
}



// WEBPACK FOOTER //
// ./src/state/modules/user/preferences/mutations.js